var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_8480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.015625C31.0374 0.015625 39.9844 8.96264 39.9844 20C39.9844 31.0374 31.0374 39.9844 20 39.9844C8.96264 39.9844 0.015625 31.0374 0.015625 20C0.015625 8.96264 8.96264 0.015625 20 0.015625ZM33.0238 9.09453L9.09453 33.0238C12.3498 35.7497 16.508 37.1577 20.7497 36.9703C24.9915 36.783 29.0093 35.0139 32.0116 32.0116C35.0139 29.0093 36.783 24.9915 36.9703 20.7497C37.1577 16.508 35.7497 12.3498 33.0238 9.09453ZM20 3.01328C16.768 3.01328 13.603 3.93533 10.8767 5.6712C8.15041 7.40706 5.9759 9.88468 4.60848 12.8132C3.24106 15.7417 2.73749 18.9995 3.15688 22.2042C3.57627 25.4089 4.90123 28.4275 6.97619 30.9055L30.9055 6.97619C27.8511 4.41102 23.9887 3.00745 20 3.01328Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_8480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNone);
export default __webpack_public_path__ + "static/media/ic_none.04eb1b117b15fcb00a2d4335b0508805.svg";
export { ForwardRef as ReactComponent };